// Texts of the ERP area "projetos" (projetos, tarefas, agenda, reuniões).
export default {
  projects: {
    title: 'Projetos',
    subtitle: 'Projetos dos clientes, com tarefas, acompanhamentos e progresso.',
    new: 'Novo projeto',
    searchPlaceholder: 'Nome, código, sigla, cliente ou responsável',
    shortcutsLabel: 'Situação',
    shortcuts: {
      all: 'Todos',
      not_started: 'Não iniciados',
      in_progress: 'Em andamento',
      waiting_customer: 'Ag. cliente',
      blocked: 'Travados',
      completed: 'Concluídos',
    },
    showCompleted: 'Mostrar concluídos',
    kindFilter: 'Tipo',
    kinds: { client: 'Externos', internal: 'Internos' },
    responsibleFilter: 'Responsável',
    customerFilter: 'Cliente',
    priorityFilter: 'Prioridade',
    count: '{n} projeto encontrado | {n} projetos encontrados',
    emptyTitle: 'Nenhum projeto encontrado',
    emptyFiltered: 'Tente ajustar os filtros.',
    emptyText: 'Crie o primeiro projeto para começar.',
    internal: 'Interno',
    open: 'Abrir',
    columns: {
      code: 'Código',
      title: 'Projeto',
      customer: 'Cliente',
      status: 'Status',
      priority: 'Prioridade',
      progress: 'Progresso',
      expectedEndDate: 'Previsão de término',
      responsible: 'Responsável',
    },
    status: {
      not_started: 'Não iniciado',
      in_progress: 'Em andamento',
      waiting_customer: 'Aguardando cliente',
      blocked: 'Travado',
      completed: 'Concluído',
      cancelled: 'Cancelado',
    },
    customerLocked: 'O projeto Geral fica sempre com a própria empresa.',
    codePreview: '(prévia; confirmado ao salvar)',
    codePending: 'Ainda sem código (Configurações › Módulo ERP › Códigos)',
    codeChooseCustomer: 'Escolha o cliente para ver o código.',
    fields: {
      code: 'Código',
      title: 'Nome',
      customer: 'Cliente',
      chooseCustomer: 'Escolha o cliente',
      mainContact: 'Contato principal',
      noContact: 'Sem contato principal',
      objective: 'Objetivo',
      scope: 'Escopo',
      customerArea: 'Área do cliente',
      customerAreaPlaceholder: 'Ex.: Controladoria, TI, Comercial',
      priority: 'Prioridade',
      status: 'Status',
      manualProgress: 'Progresso manual (%)',
      manualProgressHint: 'Vazio = calculado pelas tarefas ({n}% agora).',
      manualProgressInvalid: 'Informe um número inteiro de 0 a 100, ou deixe vazio.',
      startDate: 'Início',
      startAuto: 'registrado ao criar',
      expectedEndDate: 'Previsão de término',
      completedOn: 'Conclusão',
      completedAuto: 'registrada ao marcar "Concluído"',
      erpCode: 'Código ERP',
      erpCodeHint: 'Código deste projeto no ERP da empresa, só para referência. Não muda o nosso código.',
      risks: 'Riscos',
      notes: 'Notas',
      responsible: 'Responsável interno',
    },
    form: {
      newTitle: 'Novo projeto',
      editTitle: 'Editar projeto',
      save: 'Salvar',
      create: 'Criar projeto',
      laterHint: 'Contato, status, prioridade, valor, objetivo e escopo você completa depois, editando o projeto.',
    },
    detail: {
      back: 'Voltar',
      edit: 'Editar',
      progress: 'Progresso',
      manual: 'manual',
      openTasks: 'Tarefas abertas',
      tabs: { overview: 'Visão geral', tasks: 'Tarefas', followUps: 'Acompanhamento', meetings: 'Reuniões', files: 'Arquivos', commercial: 'Comercial', finance: 'Financeiro' },
      newTask: 'Nova tarefa',
      tasks: 'Tarefas',
      noTasks: 'Nenhuma tarefa neste projeto.',
      noFollowUps: 'Nenhum acompanhamento nas tarefas deste projeto.',
      noMeetings: 'Nenhuma reunião neste projeto.',
      openTask: 'Abrir tarefa',
      overdue: 'Atrasada',
      commercial: 'Propostas e faturas',
      noCommercial: 'Nenhuma proposta ou fatura.',
      finance: 'Financeiro',
      noFinance: 'Nenhum lançamento.',
      interactions: 'Interações de CRM',
      noInteractions: 'Nenhum acompanhamento.',
      empty: 'Nenhuma informação além do nome.',
      kind: { proposal: 'Proposta' },
      income: 'Receita',
      expense: 'Despesa',
      entryStatus: { pending: 'Pendente', paid: 'Pago', cancelled: 'Cancelado' },
      notFound: 'Projeto não encontrado',
      notFoundText: 'Ele pode ter sido excluído ou não estar na sua carteira.',
    },
    deleteText: 'As tarefas do projeto não são excluídas: continuam, sem o vínculo com ele. O mesmo vale para lançamentos e reuniões.',
  },
  // Modelos de projeto (17/10/2026).
  // Arquivos do projeto (20/10/2026).
  projectFiles: {
    title: 'Arquivos do projeto',
    add: 'Adicionar arquivo',
    addTitle: 'Adicionar arquivo ao projeto',
    added: 'Arquivo adicionado.',
    drop: 'Arraste o arquivo ou clique para escolher',
    dropHint: 'Até 8 MB.',
    tooLarge: 'O arquivo passa de 8 MB.',
    chooseType: 'Escolha o tipo',
    changeType: 'Alterar o tipo',
    changeTypeTitle: 'Alterar o tipo do arquivo',
    download: 'Baixar',
    deleteText: 'O arquivo será removido do projeto.',
    emptyTitle: 'Nenhum arquivo neste projeto',
    emptyText: 'Anexe a proposta, a aprovação do termo de abertura e o que mais fizer parte do projeto.',
    completeTitle: 'Anexe o arquivo para concluir',
    completeText: 'A tarefa “{task}” pede um arquivo do tipo “{type}” para ser concluída. Ele fica nos arquivos do projeto.',
    attachAndComplete: 'Anexar e concluir',
    needsFile: 'Pede arquivo: {type}',
    askedLabel: 'Arquivo ao concluir',
    pending: 'Falta anexar',
    sent: 'Anexado',
    fields: { type: 'Tipo de arquivo' },
    columns: { file: 'Arquivo', type: 'Tipo', task: 'Tarefa', size: 'Tamanho', by: 'Enviado por', date: 'Em' },
  },
  projectFileTypes: {
    title: 'Tipos de arquivo',
    subtitle: 'Os tipos que um arquivo de projeto pode ter, como Proposta ou História de usuário.',
    new: 'Novo tipo',
    newTitle: 'Novo tipo de arquivo',
    editTitle: 'Editar tipo de arquivo',
    emptyTitle: 'Nenhum tipo de arquivo',
    emptyText: 'Crie os tipos para classificar os arquivos dos projetos.',
    active: 'Ativo',
    inactive: 'Inativo',
    deleteText: 'O tipo será excluído. Um tipo que já foi usado não pode ser excluído: inative-o.',
    columns: { name: 'Tipo', files: 'Arquivos', state: 'Situação' },
    fields: { name: 'Nome', active: 'Ativo', activeHint: 'Um tipo inativo não aparece para escolha, mas os arquivos que já o têm continuam.' },
  },
  projectTemplates: {
    title: 'Modelos de projeto',
    subtitle: 'As tarefas com que cada tipo de projeto começa. O padrão é usado na aprovação da proposta.',
    new: 'Novo modelo',
    newTitle: 'Novo modelo de projeto',
    editTitle: 'Editar modelo de projeto',
    emptyTitle: 'Nenhum modelo de projeto',
    emptyText: 'Crie um modelo com as tarefas padrão: o projeto aprovado já nasce com elas.',
    default: 'Padrão',
    active: 'Ativo',
    inactive: 'Inativo',
    deleteText: 'O modelo será excluído. Os projetos já criados com ele não mudam.',
    addTask: 'Adicionar tarefa',
    removeTask: 'Remover a tarefa',
    moveUp: 'Subir a tarefa',
    moveDown: 'Descer a tarefa',
    orderHint: 'As tarefas são criadas nesta ordem. Uma tarefa pode começar só depois de outra, que vem antes dela, ser concluída.',
    afterNone: 'Logo no início',
    columns: { name: 'Modelo', tasks: 'Tarefas', state: 'Situação' },
    fields: {
      name: 'Nome',
      description: 'Descrição',
      isDefault: 'Modelo padrão',
      isDefaultHint: 'Usado quando a proposta não escolhe um modelo e nenhum produto dela tem modelo.',
      projectTitle: 'Nome do projeto',
      projectTitleHint: 'O nome do projeto criado ao aprovar a proposta. Vazio = o nome da proposta.',
      projectTitlePlaceholder: 'Ex.: Diagnóstico',
      active: 'Ativo',
      tasks: 'Tarefas',
      taskTitle: 'Tarefa',
      days: 'Prazo (dias após o início)',
      daysAfterDone: 'Prazo (dias após concluir a anterior)',
      startsAfter: 'Começa depois de',
      askFile: 'Pedir arquivo ao concluir',
      priority: 'Prioridade',
    },
    noFileAsked: 'Nenhum',
    apply: 'Aplicar modelo',
    applyTitle: 'Aplicar modelo ao projeto',
    applyText: 'As tarefas do modelo entram no projeto, com o responsável dele. As tarefas que já existem continuam.',
    choose: 'Modelo',
    optionTasks: '{name} ({n} tarefas)',
    applied: 'Nenhuma tarefa criada. | 1 tarefa criada. | {n} tarefas criadas.',
    proposalField: 'Modelo de projeto',
    proposalDefault: 'O do produto, senão o padrão ({name})',
    proposalNone: 'O do produto (se tiver)',
    proposalHint: 'Na aprovação, o projeto é criado com as tarefas deste modelo. Sem escolher, vale o modelo do produto no catálogo.',
  },
  tasks: {
    // Criar rápido (17/10/2026): the title and Enter, on top of the list.
    quick: {
      placeholder: 'Nova tarefa: digite o título e tecle Enter',
      project: 'Projeto',
      noProject: 'Sem projeto · {customer}',
      add: 'Adicionar',
      created: 'Tarefa {code} criada.',
      needsProject: 'Escolha o projeto (ou filtre um cliente) para criar a tarefa.',
      error: 'A tarefa não foi criada',
    },
    title: 'Tarefas',
    subtitle: 'Tarefas dos clientes, com prazo e acompanhamentos.',
    new: 'Nova tarefa',
    views: { label: 'Visualização', list: 'Lista', board: 'Quadro' },
    shortcutsLabel: 'Situação',
    shortcuts: {
      active: 'Ativas',
      all: 'Todas',
      todo: 'A fazer',
      in_progress: 'Em andamento',
      waiting_return: 'Ag. retorno',
      done: 'Concluídas',
      cancelled: 'Canceladas',
      due_overdue: 'Prazo atrasado',
    },
    filters: {
      dueFrom: 'Prazo de',
      dueTo: 'Prazo até',
      searchPlaceholder: 'Código, projeto, título, cliente ou responsável',
      customer: 'Cliente',
      project: 'Projeto',
      priority: 'Prioridade',
      responsible: 'Contato do cliente',
      owner: 'Responsável',
    },
    count: '{n} tarefa encontrada | {n} tarefas encontradas',
    emptyTitle: 'Nenhuma tarefa encontrada',
    emptyFiltered: 'Tente ajustar os filtros.',
    emptyText: 'Crie a primeira tarefa para começar.',
    emptyColumn: 'Arraste tarefas para cá',
    dropZone: 'Solte aqui para mudar o status',
    hiddenColumn: 'Fora deste filtro',
    movedTo: '“{title}” agora está em {status}',
    reorderError: 'Não foi possível mover a tarefa. Ela voltou para onde estava.',
    overdue: 'Atrasada',
    // 20/10/2026: a task of a model that starts after another one is done.
    blocked: 'Aguardando {task}',
    blockedHint: 'Só pode começar depois que {task} for concluída.',
    startsAfter: 'Começa depois de',
    sortBy: 'Ordenar por {column}',
    open: 'Abrir',
    columns: {
      code: 'Código',
      title: 'Tarefa',
      customer: 'Cliente',
      status: 'Status',
      priority: 'Prioridade',
      due: 'Prazo',
      owner: 'Responsável',
      responsible: 'Contato do cliente',
      completed: 'Conclusão',
    },
    status: { todo: 'A fazer', in_progress: 'Em andamento', waiting_return: 'Aguardando retorno', done: 'Concluída', cancelled: 'Cancelada' },
    priority: { low: 'Baixa', medium: 'Média', high: 'Alta', critical: 'Crítica' },
    fields: {
      customer: 'Cliente',
      project: 'Projeto',
      noProject: 'Sem projeto',
      chooseCustomer: 'Escolha o cliente',
      chooseCustomerFirst: 'Escolha o cliente primeiro',
      owner: 'Responsável',
      responsible: 'Contato do cliente',
      noResponsible: 'Sem responsável externo',
      title: 'Título',
      description: 'Descrição',
      origin: 'Origem',
      originPlaceholder: 'Ex.: reunião, e-mail, demanda espontânea',
      priority: 'Prioridade',
      status: 'Status',
      dueDate: 'Prazo',
      code: 'Código',
      codePending: 'Gerado quando a tarefa entrar num projeto',
      projectLocked: 'A tarefa não muda de projeto depois de ter código. Para levá-la a outro, crie uma tarefa nova lá e cancele esta.',
      completedOn: 'Data de conclusão',
      completedPending: 'Registrada automaticamente ao concluir',
      cancelledOn: 'Cancelada em',
      notes: 'Notas internas',
    },
    detail: {
      heading: 'Tarefa',
      back: 'Voltar',
      identification: 'Identificação',
      properties: 'Detalhes',
      created: 'Criada por',
      dates: 'Datas',
      other: 'Demais informações',
      edit: 'Editar',
      saving: 'Salvando…',
      saved: 'Salvo',
      clear: 'Limpar',
      titleRequired: 'O título não pode ficar vazio.',
      titleHint: 'Enter salva, Esc desfaz.',
      createdBy: 'Criada por {name} em {date}',
      notFound: 'Tarefa não encontrada',
      notFoundText: 'Ela pode ter sido excluída ou não estar na sua carteira.',
      deleteText: 'A tarefa sai de todas as listas e da Agenda.',
    },
    form: {
      newTitle: 'Nova tarefa',
      editTitle: 'Editar tarefa',
      save: 'Salvar',
      create: 'Criar tarefa',
    },
    followUps: {
      title: 'Acompanhamentos',
      empty: 'Nenhum acompanhamento registrado ainda.',
      placeholder: 'O que aconteceu e quais os próximos passos',
      date: 'Data',
      add: 'Registrar',
      shortcut: 'Ctrl+Enter registra',
      minLength: 'Escreva pelo menos 3 caracteres.',
      edit: 'Editar acompanhamento',
      deleteTitle: 'Excluir este acompanhamento?',
      deleteText: 'O acompanhamento será removido da tarefa.',
    },
  },
  calendar: {
    title: 'Agenda',
    subtitle: 'Tarefas no dia do prazo, reuniões, atividades do CRM e vencimentos do financeiro.',
    newMeeting: 'Nova reunião',
    views: { label: 'Visualização', day: 'Dia', week: 'Semana', month: 'Mês' },
    today: 'Hoje',
    previous: 'Anterior',
    next: 'Próximo',
    pickDay: 'Data',
    filters: {
      customer: 'Cliente',
      project: 'Projeto',
      responsible: 'Contato do cliente (tarefas)',
      owner: 'Responsável',
      ownerHint: 'Tarefas e atividades da pessoa, e as reuniões que ela marcou ou em que é convidada.',
      kind: 'Tipo',
      showCompleted: 'Mostrar concluídas',
      showDeclined: 'Mostrar as recusadas',
    },
    meetings: 'Reuniões',
    tasks: 'Tarefas com prazo',
    overdue: 'Atrasada',
    due: 'Prazo {date}',
    items: 'Nenhum item | 1 item | {n} itens',
    meetingsCount: '{n} reunião | {n} reuniões',
    tasksCount: '{n} tarefa | {n} tarefas',
    activitiesCount: '{n} atividade | {n} atividades',
    customerContact: 'contato: {name}',
    activities: 'Atividades do CRM',
    viewDay: 'Ver dia',
    emptyToday: 'Nenhum item para hoje',
    emptyDay: 'Nenhum item para este dia',
    emptyHint: 'Tarefas com prazo, reuniões, atividades do CRM e vencimentos aparecem aqui.',
    emptyFiltered: 'Tente remover os filtros.',
    openDay: 'Abrir {day}',
    overdueTitle: 'Atrasadas',
    overdueHint: 'Ainda pendentes de dias anteriores, em qualquer período.',
    daysLate: 'venceu hoje | há 1 dia | há {n} dias',
    searchPlaceholder: 'Buscar na agenda (título, cliente, projeto, pessoa)',
    kinds: {
      meeting: 'Reunião',
      task: 'Tarefa',
      activity: 'Atividade',
      due: 'Vencimento',
      google: 'Google',
      all: 'Todos',
      plural: { meetings: 'Reuniões', tasks: 'Tarefas', activities: 'Atividades', dues: 'Vencimentos', google: 'Google Agenda' },
    },
    areas: { label: 'Áreas', all: 'Todas', commercial: 'Comercial', projects: 'Projetos', finance: 'Financeiro', general: 'Interno' },
    dues: 'Vencimentos',
    duesCount: '{n} vencimento | {n} vencimentos',
    dueOverdue: 'Vencido',
    dueType: { income: 'A receber', expense: 'A pagar' },
    settled: { income: 'Recebido', expense: 'Pago' },
    cardInvoice: 'Fatura do cartão',
    google: {
      title: 'Google Agenda',
      allDay: 'Dia inteiro',
      joinMeet: 'Entrar no Meet',
      // The event's window (Etapa 3, 17/10/2026): everything here, nothing opens Google.
      event: {
        title: 'Evento',
        // 22/10/2026: the Google event becomes the meeting (linked, never twice in the agenda).
        register: 'Registrar como reunião',
        editTitle: 'Editar evento',
        when: 'Quando',
        where: 'Onde',
        organizer: 'Organizado por',
        recurring: 'repete',
        recurringHint: 'Este evento se repete: a mudança vale só para esta data.',
        going: 'Vai participar?',
        answer: { accepted: 'Sim', tentative: 'Talvez', declined: 'Não' },
        answered: 'Resposta enviada ao organizador.',
        edit: 'Editar',
        saved: 'Evento atualizado. O Google avisa os convidados.',
        delete: 'Excluir',
        deleteTitle: 'Excluir este evento?',
        deleteText: 'Ele sai da sua agenda e da agenda dos convidados, e o Google avisa todos.',
        deleteRecurring: 'Este evento se repete: só esta data é excluída.',
        deleted: 'Evento excluído.',
        remove: 'Remover da minha agenda',
        removeTitle: 'Remover da sua agenda?',
        removeText: 'O evento sai só da sua agenda; quem organiza continua com ele.',
        removed: 'Evento removido da sua agenda.',
        fields: {
          title: 'Título',
          allDay: 'Dia inteiro',
          firstDay: 'Primeiro dia',
          lastDay: 'Último dia',
          startsAt: 'Início',
          endsAt: 'Fim',
          location: 'Local',
          description: 'Descrição',
        },
      },
      error: 'Os eventos do Google Agenda não puderam ser carregados: {message}',
    },
  },
  meetings: {
    title: 'Reuniões',
    // "Registrar reunião realizada" (19/10/2026).
    held: {
      title: 'Registrar reunião realizada',
      next: 'Continuar para o relatório',
      titleFor: 'Reunião com {customer}',
      fromGoogle: 'Do seu Google neste dia (use o evento para não ficar duas vezes na agenda)',
      linked: 'Esta reunião fica ligada ao evento do Google: na agenda aparece uma vez só.',
    },
    // "Enviar por e-mail" of the record (19/10/2026).
    report: {
      open: 'Enviar por e-mail',
      title: 'Enviar o relatório da reunião',
      to: 'Para',
      toHint: 'E-mails separados por vírgula. O padrão fica em Configurações › Módulo ERP › Documentos.',
      subject: 'Assunto',
      preview: 'Como vai no e-mail',
      signature: 'Sua assinatura vai no fim. As respostas chegam no seu e-mail, e você recebe uma cópia.',
      send: 'Enviar',
      later: 'Agora não',
      sent: 'Relatório enviado.',
      sentGmail: 'Relatório enviado pelo seu Gmail. Ele está nos seus Enviados.',
      viaGmail: 'Vai pelo seu Gmail e fica nos seus Enviados.',
      reconnect: 'Abrir Integrações',
      lastSent: 'Já enviado em {date} para {to} (por {name}).',
    },
    // "Vai participar?" (19/10/2026).
    answer: {
      question: 'Vai participar?',
      answers: 'Respostas dos convidados',
      accepted: 'Sim',
      tentative: 'Talvez',
      declined: 'Não',
      declinedHint: 'Ela saiu da sua agenda e do seu To Do. Fica em Reuniões › Recusadas por mim.',
      savedNotGoogle: 'Resposta salva, mas não foi para o Google Agenda',
      saved: {
        accepted: 'Presença confirmada.',
        tentative: 'Marcado como talvez.',
        declined: 'Reunião recusada: saiu da sua agenda e do seu To Do.',
      },
      you: { declined: 'Você recusou', tentative: 'Talvez' },
    },
    searchPlaceholder: 'Título, participantes, cliente ou projeto',
    subtitle: 'Reuniões com ata, participantes e gravação.',
    new: 'Nova reunião',
    projectFilter: 'Projeto',
    views: { label: 'Visualização', cards: 'Cards', list: 'Lista' },
    count: '{n} reunião encontrada | {n} reuniões encontradas',
    columns: { title: 'Reunião', heldAt: 'Data', state: 'Situação', modality: 'Modalidade', guests: 'Convidados' },
    emptyTitle: 'Nenhuma reunião aqui',
    emptyText: 'Marque uma reunião ou escolha outro atalho acima.',
    heldAt: '{date} às {time}',
    modality: { none: 'Não informado', in_person: 'Presencial', remote: 'Online' },
    kind: {
      label: 'Tipo de reunião',
      commercial: 'Comercial',
      project: 'Projeto',
      internal: 'Interna',
      hint: {
        commercial: 'Com um cliente ou prospect: entra no histórico do cliente no CRM.',
        project: 'De um projeto do cliente: aparece no projeto e no histórico do cliente.',
        internal: 'Só da equipe: não vai para o CRM nem para um projeto.',
      },
    },
    dialogNew: 'Nova reunião',
    dialogEdit: 'Editar reunião',
    fields: {
      title: 'Título',
      heldAt: 'Data e hora',
      project: 'Projeto',
      customer: 'Cliente (vira acompanhamento no CRM)',
      participants: 'Participantes',
      modality: 'Modalidade',
      placeName: 'Local',
      address: 'Endereço',
      city: 'Cidade',
      meetingUrl: 'Link da reunião',
      minutes: 'Ata',
      recordingUrl: 'Link da gravação',
      recordingPlaceholder: 'Ex.: link do Granola',
      duration: 'Duração',
      chooseProject: 'Escolha o projeto',
      chooseCustomerFirst: 'Escolha o cliente primeiro',
      meetOnSave: 'O link do Google Meet é gerado ao salvar e aparece na reunião.',
      meetReady: 'O link do Google Meet já está na reunião.',
      otherLink: 'Link da reunião (Zoom, Teams…)',
      guests: 'Convidados (e-mails)',
      guestsHint: 'Recebem o convite do Google Agenda. Separe por vírgula.',
      guestsSuggestions: 'Adicionar',
      removeGuest: 'Tirar {email} dos convidados',
    },
    durations: { 15: '15 min', 30: '30 min', 45: '45 min', 60: '1 hora', 90: '1h30', 120: '2 horas', 180: '3 horas' },
    // Free/busy of each guest in Google Agenda at the meeting's time (17/10/2026).
    availability: { free: 'Livre', busy: 'Ocupado', unknown: 'Sem acesso' },
    openRecording: 'Abrir gravação',
    openMeeting: 'Entrar na reunião',
    record: {
      title: 'Registrar reunião',
      titleDone: 'Registro da reunião',
      // Before its time (19/10/2026).
      early: 'Registrar',
      earlyTitle: 'Registrar a reunião agora?',
      earlyText: 'Ela está marcada para {date}. Se você registrar que aconteceu, o horário dela passa a ser agora (no Google Agenda também).',
      earlyHint: 'Registrada antes do horário: se aconteceu, o horário passa a ser agora.',
      how: 'Como foi?',
      outcome: { held: 'Aconteceu', not_held: 'Não aconteceu', reschedule: 'Remarcar' },
      summary: 'Resumo',
      summaryHint: 'O que foi conversado.',
      reason: 'Motivo (opcional)',
      decisions: 'Decisões',
      nextSteps: 'Próximos passos',
      nextStep: 'Próximo passo {n}',
      addStep: 'Adicionar passo',
      removeStep: 'Remover passo',
      tasks: 'Tarefas do projeto',
      tasksHint: 'Criadas no projeto {project} ao salvar o registro.',
      addTask: 'Adicionar tarefa ao projeto',
      removeTask: 'Remover tarefa',
      taskTitle: 'Tarefa',
      dueDate: 'Prazo',
      owner: 'Responsável',
      editSchedule: 'Editar agendamento',
      save: 'Salvar registro',
      saved: 'Registro salvo.',
      created: 'Nenhuma tarefa criada. | 1 tarefa criada no projeto. | {n} tarefas criadas no projeto.',
      recordedBy: 'Registrada por {name} em {date}',
    },
    inGoogle: {
      title: 'Google Agenda',
      join: 'Entrar no Meet',
      refresh: 'Atualizar respostas',
      guests: 'Convidados',
      organizer: 'organizador',
      noGuests: 'Nenhum convidado.',
      notInGoogle: 'Esta reunião não está no Google Agenda.',
      response: { needs_action: 'Não respondeu', accepted: 'Aceitou', declined: 'Recusou', tentative: 'Talvez' },
      summary: '{accepted} de {total} aceitaram',
    },
    status: { upcoming: 'Próxima', pending: 'A registrar', held: 'Registrada', not_held: 'Não aconteceu' },
    shortcuts: { upcoming: 'Próximas', pending: 'A registrar', recorded: 'Registradas', declined: 'Recusadas por mim', all: 'Todas' },
    pendingBanner: 'Você tem {n} reunião para registrar. | Você tem {n} reuniões para registrar.',
    pendingAction: 'Registrar agora',
    integrationsLink: 'Conectar em Integrações',
    // After saving: whether the guests got an e-mail (the invitations are sent by Google).
    invites: {
      sentTitle: 'Convites enviados pelo Google',
      sent: 'O convidado recebeu o convite por e-mail. | Os {n} convidados receberam o convite por e-mail.',
      noGuests: 'Está na sua agenda Google. Sem convidados, ninguém recebeu convite.',
      notSentTitle: 'Reunião criada, sem convites',
      optionOff: 'Os convidados não receberam e-mail: a opção do Google Agenda estava desligada.',
      noGoogle: 'Os convidados não receberam e-mail. Para enviar convites, conecte a sua conta Google em Integrações.',
    },
    google: {
      title: 'Google Agenda',
      connectText: 'Conecte a sua conta Google para criar a reunião na sua agenda, com link do Meet e convites.',
      connect: 'Conectar conta Google',
      reconnectText: 'O Google recusou o acesso à sua agenda. Conecte a conta de novo.',
      connectedAs: 'Conectado como {email}',
      disconnect: 'Desconectar',
      disconnected: 'Conta Google desconectada.',
      add: 'Criar no Google Agenda e enviar os convites',
      keep: 'Manter no Google Agenda',
      meet: 'Gerar link do Google Meet',
      inGoogle: 'No Google Agenda',
      savedWithWarning: 'Reunião salva, mas não foi para o Google Agenda',
      connected: 'Conta Google conectada.',
      errors: {
        negado: 'A conexão com o Google foi cancelada.',
        'outra-conta': 'Use a conta Google do seu e-mail de acesso.',
        expirado: 'O link de conexão expirou. Tente de novo.',
        falhou: 'Não foi possível conectar ao Google. Tente de novo.',
      },
    },
  },
}
